import { createI18nInstance } from 'remote/global';
import i18n from 'i18next';

const defaultNS = 'translation';
const projectPaths = [
  {
    projectToken: '4ad3601890614f259b0a8feb102a1033', // Mobifer Common Translations
    ns: ['common'],
  },
  {
    projectToken: 'f7dcf507c54f4f9bb1fe0bbde91a349d', // Mobifer Operator FE
    ns: [defaultNS],
  },
];

const localI18nInstance = createI18nInstance(projectPaths, 'operator');

export { localI18nInstance };
export default i18n;
